import { CropConstants } from './constants/Crop';
import { isBrazil } from './countryCode';

/**
 * In Brazil the crop season is what separates a first-season (Safra) corn
 * recommendation from a second-season (Safrinha) one. `crop_type` alone does
 * not carry it, so crop_id is the authoritative discriminator.
 */
const BRAZIL_CROP_SEASONS: Record<number, string> = {
  [CropConstants.CORN_CROP_ID]: 'Safrinha',
  [CropConstants.SUMMER_CORN_CROP_ID]: 'Safra',
};

const BRAZIL_SEASON_MONTHS = {
  Safrinha: [1, 2, 3, 4, 5, 6, 7],
  Safra: [8, 9, 10, 11, 12],
} as const;

export const getBrazilCropSeasonMonths = (
  season: string | undefined
): readonly number[] | undefined => {
  if (season !== 'Safra' && season !== 'Safrinha') {
    return undefined;
  }
  return BRAZIL_SEASON_MONTHS[season];
};

export const getBrazilCropSeason = (
  country: string | undefined,
  cropId: number | string | undefined
): string | undefined => {
  if (!isBrazil(country) || cropId === undefined || cropId === null || cropId === '') {
    return undefined;
  }
  return BRAZIL_CROP_SEASONS[Number(cropId)];
};

/**
 * Crop name with the Brazilian season spelled out ("Safrinha Corn"), so a
 * consumer can never mistake a Safrinha recommendation for a Safra or soy one.
 * Returns the crop name untouched outside Brazil, for soybeans, or when the
 * name already names the season.
 */
export const getSeasonAwareCropName = (
  country: string | undefined,
  cropId: number | string | undefined,
  cropName: string | undefined
): string | undefined => {
  const season = getBrazilCropSeason(country, cropId);
  if (!season || !cropName) {
    return cropName;
  }
  return cropName.toLowerCase().includes(season.toLowerCase()) ? cropName : `${season} ${cropName}`;
};
